export const newsList = [
  {
    id: "news-2025-1008",
    title: "AI 短剧进入「精品季」：单集 15 分钟成为新主流",
    summary: "从年初的 3 分钟试水到如今 15 分钟的正片体量，AI 短剧正在完成一次质地跃迁——更长的时长意味着更完整的叙事。",
    category: "行业动态",
    tags: ["行业趋势", "精品化", "时长"],
    date: "2025-10-08",
    author: "ai短剧编辑部",
    cover: "https://readdy.ai/api/search-image?query=Modern%20editorial%20illustration%20of%20a%20glowing%20film%20strip%20transforming%20into%20digital%20light%20particles%2C%20deep%20navy%20background%20with%20warm%20orange%20accents%2C%20clean%20minimal%20tech%20composition%2C%20high%20detail%2C%20abstract%20cinematic%20mood%2C%20no%20text&width=900&height=560&seq=aisd-news-01&orientation=landscape",
    content: [
      { type: "p", text: "过去一年，人工智能参与创作的短剧从「概念演示」快速走向「可看内容」。最直观的变化是时长：年初大量作品停留在 2 到 3 分钟的样品阶段，而进入下半年后，单集 12 至 15 分钟、整季 6 到 10 集的结构逐渐成为主流配置。" },
      { type: "p", text: "时长的拉长并不只是把内容撑长。更完整的篇幅意味着人物需要真实的动机，情节需要经得起推敲的转折，镜头语言也从「炫技式展示」转向为叙事服务。多位创作者在访谈中提到，当生成工具的效率提升后，他们把省下来的时间重新投回了剧本打磨。" },
      { type: "img", src: "https://readdy.ai/api/search-image?query=Widescreen%20creative%20studio%20workspace%20with%20multiple%20glowing%20monitors%20showing%20storyboards%2C%20warm%20desk%20lighting%20against%20cool%20blue%20ambient%20light%2C%20clean%20modern%20atmosphere%2C%20cinematic%20detail%2C%20no%20text&width=1200&height=700&seq=aisd-news-01b&orientation=landscape", caption: "越来越多团队把 AI 生成结果当作分镜参考，再回到剧本阶段反复打磨。" },
      { type: "p", text: "我们也注意到，观众对 AI 短剧的期待正在变化。早期的好奇心红利正在消退，取而代之的是对「故事本身是否成立」的认真审视。这对创作者来说反而是好消息——当技术不再是唯一的谈资，内容能力才真正被看见。" },
    ],
  },
  {
    id: "news-2025-0928",
    title: "《星轨之下》上线首周播放破千万，硬核科幻回潮",
    summary: "这部只有 8 集的 AI 科幻短剧，用克制的叙事和扎实的设定，让硬核题材重新回到年轻人的观看清单。",
    category: "作品观察",
    tags: ["科幻", "爆款", "深度解析"],
    date: "2025-09-28",
    author: "观剧小组",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20editorial%20image%20of%20an%20astronaut%20silhouette%20facing%20a%20giant%20ringed%20planet%2C%20deep%20navy%20space%20with%20subtle%20warm%20rim%20light%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20dramatic%20atmosphere%2C%20no%20text&width=900&height=560&seq=aisd-news-02&orientation=landscape",
    content: [
      { type: "p", text: "《星轨之下》讲述一艘失联十二年的深空探测船突然重新发回信号，三名留守工程师必须在四十八小时内做出选择。全剧没有一场过度渲染的爆炸戏，几乎所有的张力都来自「等待」与「判断」。" },
      { type: "p", text: "这种克制恰恰是它出圈的原因。在短视频普遍追求前三秒爽点的环境里，它反其道而行，把悬念埋进对话和仪表读数里，让观众主动参与到推理中。" },
      { type: "p", text: "从制作层面看，该剧的太空场景全部由 AI 参与生成，但团队花了大量精力做色彩统一与物理合理性校验，最终呈现出接近院线的视觉质感，这也是它被反复讨论的原因之一。" },
    ],
  },
  {
    id: "news-2025-0920",
    title: "当 AI 开始写群像：多线叙事短剧的三条经验",
    summary: "《归途列车》《云端彼端》等作品证明，多线叙事并非长片专利，短剧同样可以用六条线讲清一个主题。",
    category: "创作手记",
    tags: ["创作", "群像", "方法论"],
    date: "2025-09-20",
    author: "创作观察室",
    cover: "https://readdy.ai/api/search-image?query=Widescreen%20conceptual%20image%20of%20multiple%20film%20frames%20arranged%20in%20a%20flowing%20line%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20clean%20editorial%20design%2C%20high%20detail%20abstract%20composition%2C%20no%20text&width=900&height=560&seq=aisd-news-03&orientation=landscape",
    content: [
      { type: "p", text: "群像剧最难的地方，是让每条线都值得被看见。短剧的篇幅不允许铺陈，因此创作者必须在开场十分钟内让观众记住每一个角色，并且理解他们之间的关联。" },
      { type: "p", text: "第二个经验是「共享同一个场景」。把六条线放进同一趟列车、同一间便利店，天然形成了叙事的黏合剂，也让转场变得顺理成章。" },
      { type: "p", text: "最后一点是关于结尾：优秀的群像短剧不会强行让所有线收束在一处，而是让它们在同一个主题下各自抵达，留下开放的余味。" },
    ],
  },
  {
    id: "news-2025-0912",
    title: "AI 短剧的配乐革命：生成式声音如何服务叙事",
    summary: "从环境音到主题旋律，生成式音频工具正在改变短剧的声音设计流程，也让独立创作者第一次拥有了「配乐自由」。",
    category: "技术前沿",
    tags: ["配乐", "声音设计", "技术"],
    date: "2025-09-12",
    author: "声音研究所",
    cover: "https://readdy.ai/api/search-image?query=Widescreen%20abstract%20visualization%20of%20sound%20waves%20in%20warm%20orange%20and%20cool%20blue%2C%20dark%20navy%20background%2C%20glowing%20audio%20waveform%20bars%2C%20elegant%20minimal%20tech%20composition%2C%20high%20detail%2C%20no%20text&width=900&height=560&seq=aisd-news-04&orientation=landscape",
    content: [
      { type: "p", text: "声音曾经是短剧制作中最容易被牺牲的一环。预算有限时，配乐往往只能从素材库挑选，导致大量作品听起来高度相似。" },
      { type: "p", text: "生成式音频工具改变了这一点。创作者可以按情绪、时长、乐器编制描述需求，快速得到可用的候选旋律，再人工挑选与调整。" },
      { type: "p", text: "但工具带来便利的同时也带来新的问题：如何避免「听起来都对，却没有记忆点」。业内较为共识的做法是，把生成结果只当作起点，主题动机仍然由人来定义。" },
    ],
  },
  {
    id: "news-2025-0905",
    title: "《梦境交易所》的设定拆解：一个隐喻如何撑起七集",
    summary: "把「好梦可以买卖」这个单一设定，拓展成完整世界观的短剧，值得所有写设定的人研究。",
    category: "作品观察",
    tags: ["设定", "奇幻", "拆解"],
    date: "2025-09-05",
    author: "观剧小组",
    cover: "https://readdy.ai/api/search-image?query=Surreal%20editorial%20image%20of%20glowing%20bottled%20dreams%20floating%20above%20a%20night%20market%2C%20deep%20indigo%20sky%20with%20warm%20golden%20lanterns%2C%20dreamlike%20painterly%20composition%2C%20high%20detail%2C%20no%20text&width=900&height=560&seq=aisd-news-05&orientation=landscape",
    content: [
      { type: "p", text: "《梦境交易所》的核心设定只有一句话：在这座城市，好梦是可以买卖的。听起来像是一个短篇的点子，但它被撑起了整整七集。" },
      { type: "p", text: "诀窍在于把设定「制度化」。交易所需要有定价规则、有中间商、有违约惩罚，甚至有一套黑市。当规则足够具体，故事就自然生长出来。" },
      { type: "p", text: "更重要的是，这个设定指向了现实：当代人对睡眠、对情绪价值的焦虑。好的奇幻设定从来不是逃离现实，而是换一种方式注视现实。" },
    ],
  },
  {
    id: "news-2025-0826",
    title: "短剧出海观察：AI 译制让内容跨越语言门槛",
    summary: "多语种配音与字幕的自动化，让中文 AI 短剧第一次具备了低成本出海的可能性。",
    category: "行业动态",
    tags: ["出海", "译制", "全球化"],
    date: "2025-08-26",
    author: "ai短剧编辑部",
    cover: "https://readdy.ai/api/search-image?query=Widescreen%20globe%20made%20of%20glowing%20network%20lines%20and%20language%20symbols%2C%20deep%20navy%20and%20warm%20orange%20accents%2C%20clean%20minimal%20tech%20illustration%2C%20high%20detail%2C%20no%20text&width=900&height=560&seq=aisd-news-06&orientation=landscape",
    content: [
      { type: "p", text: "内容出海的第一道门槛永远是语言。传统译制流程成本高、周期长，对短剧这种高频更新的内容形态并不友好。" },
      { type: "p", text: "AI 译制把这道门槛显著降低了：字幕可以批量生成并校对，多语种配音也能在保持一致音色的前提下完成切换。" },
      { type: "p", text: "当然，文化语境仍然是难点。一句在中文里成立的玩笑，直译后可能完全失效。因此目前的出海作品，大多仍需要本地化编辑做最后一道把关。" },
    ],
  },
  {
    id: "news-2025-0818",
    title: "从《雾城回声》聊氛围感：悬疑短剧的视听功课",
    summary: "悬疑不靠血腥，靠的是雾、光、和那些没有说出口的话。",
    category: "创作手记",
    tags: ["悬疑", "氛围", "视听"],
    date: "2025-08-18",
    author: "创作观察室",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20widescreen%20still%20of%20a%20foggy%20city%20street%20at%20dawn%20with%20a%20lone%20streetlamp%2C%20muted%20blue%20grey%20palette%2C%20cinematic%20mood%2C%20high%20detail%2C%20quiet%20tense%20composition%2C%20no%20text&width=900&height=560&seq=aisd-news-07&orientation=landscape",
    content: [
      { type: "p", text: "《雾城回声》里几乎没有直接的暴力镜头，但它依然让人脊背发凉。原因在于氛围的持续压迫感。" },
      { type: "p", text: "雾是一个非常好用的视觉母题：它既遮蔽信息，又制造层次。摄影上，团队刻意压低了饱和度，只在少数关键位置保留暖光，让观众的视线有落点。" },
      { type: "p", text: "声音同样重要。大量的环境音、低频的嗡鸣，以及刻意的留白，共同构建了那种「有什么不对劲」的直觉。" },
    ],
  },
  {
    id: "news-2025-0810",
    title: "2025 下半年值得关注的 6 部 AI 短剧",
    summary: "科幻、悬疑、古装、动画全线开花，这份片单帮你快速找到自己的口味。",
    category: "片单推荐",
    tags: ["片单", "推荐", "盘点"],
    date: "2025-08-10",
    author: "ai短剧编辑部",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20grid%20of%20six%20glowing%20film%20frames%20floating%20in%20dark%20navy%20space%2C%20warm%20orange%20highlights%2C%20clean%20minimal%20design%2C%20high%20detail%20abstract%20composition%2C%20no%20text&width=900&height=560&seq=aisd-news-08&orientation=landscape",
    content: [
      { type: "p", text: "如果你喜欢硬核科幻，可以从《星轨之下》和《记忆褶皱》开始；偏爱悬疑氛围的观众，《第七封邮件》与《雾城回声》不会让你失望。" },
      { type: "p", text: "想看轻松一点的，《老板不在的日子》和《外星室友》体量轻、节奏快，特别适合通勤时观看。" },
      { type: "p", text: "而如果你在意画面与设定，《梦境交易所》《云端彼端》《锦书难寄》三部作品在美术层面各有惊喜，值得完整看完一季。" },
    ],
  },
  {
    id: "news-2025-0802",
    title: "短剧的「第一分钟」：留存率背后的叙事逻辑",
    summary: "为什么有的短剧能让观众一集不落地看完？答案往往藏在开场六十秒里。",
    category: "创作手记",
    tags: ["叙事", "留存", "方法论"],
    date: "2025-08-02",
    author: "创作观察室",
    cover: "https://readdy.ai/api/search-image?query=Widescreen%20abstract%20image%20of%20a%20glowing%20hourglass%20made%20of%20light%2C%20deep%20navy%20background%20with%20warm%20amber%20accents%2C%20clean%20minimal%20tech%20composition%2C%20high%20detail%2C%20no%20text&width=900&height=560&seq=aisd-news-09&orientation=landscape",
    content: [
      { type: "p", text: "短剧没有试错的余地。观众的手指随时可以划走，因此开场六十秒几乎决定了整部作品的命运。" },
      { type: "p", text: "高效的开场通常做两件事：给出一个具体的、未完成的情境，同时制造一个明确的疑问。不需要交代全部背景，但要让观众知道「这里有事发生」。" },
      { type: "p", text: "反面案例是把最有噱头的画面放在最前面，却没有为它埋下任何问题。视觉冲击会过去，悬念才会留下。" },
    ],
  },
  {
    id: "news-2025-0720",
    title: "古装 AI 短剧的美学突围：《锦书难寄》做对了什么",
    summary: "当 AI 遇上东方美学，难点从来不是「像不像」，而是「有没有味道」。",
    category: "作品观察",
    tags: ["古装", "美学", "深度解析"],
    date: "2025-07-20",
    author: "观剧小组",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20ink%20wash%20inspired%20editorial%20image%20with%20warm%20lantern%20light%20against%20deep%20indigo%2C%20calligraphy%20brush%20and%20scrolls%2C%20refined%20oriental%20composition%2C%20high%20detail%2C%20no%20text&width=900&height=560&seq=aisd-news-10&orientation=landscape",
    content: [
      { type: "p", text: "古装题材对美术的要求极高，稍有不慎就会显得廉价。AI 生成的优势在于细节密度，挑战则在于统一性。" },
      { type: "p", text: "《锦书难寄》的做法是先把整部剧的色彩基调收敛到「暖黄 + 靛蓝」两个色系，再让所有场景在这套规则内变化，因此画面始终统一而高级。" },
      { type: "p", text: "此外，团队刻意减少了特效的使用，把重心放在道具、光位和构图上。这种「减法」反而让东方美学更清晰地被感知。" },
    ],
  },
];